// extracted by mini-css-extract-plugin
export default {"BlockingModal-container":"BlockingModal-container2g4hWFapOq4C","BlockingModal-body":"BlockingModal-body1JfRdPq8DPr9"};